LOAD_STATE =
  EMPTY: 'empty'
  LOADING: 'loading'
  LOADED: 'loaded'

module.exports = LOAD_STATE